
/*!
 * Bubble Slider
 * https://github.com/dahjson/bubble-slider
 * Copyright (c) Daniel Johnson
 * MIT License
 */

(function() {
  (function($) {
    var BubbleSlider;
    BubbleSlider = (function() {
      function BubbleSlider(element, options) {
        var ref, ref1, ref10, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9;
        this.element = element;
        this.element.hide();
        this.min = (ref = this.element.attr('min')) != null ? ref : options.min;
        this.max = (ref1 = this.element.attr('max')) != null ? ref1 : options.max;
        this.step = (ref2 = this.element.attr('step')) != null ? ref2 : options.step;
        this.value = (ref3 = this.element.attr('value')) != null ? ref3 : (options.max - options.min) / 2 + options.min;
        this.decimals = (ref4 = this.element.data('decimals')) != null ? ref4 : options.decimals;
        this.prefix = (ref5 = this.element.data('prefix')) != null ? ref5 : options.prefix;
        this.postfix = (ref6 = this.element.data('postfix')) != null ? ref6 : options.postfix;
        this.color = (ref7 = this.element.data('color')) != null ? ref7 : options.color;
        this.bgColor = (ref8 = this.element.data('bg-color')) != null ? ref8 : options.bgColor;
        this.bubbleColor = (ref9 = this.element.data('bubble-color')) != null ? ref9 : options.bubbleColor;
        this.bubbleBgColor = (ref10 = this.element.data('bubble-bg-color')) != null ? ref10 : options.bubbleBgColor;
        this.min = parseFloat(this.removeCommas(this.min));
        this.max = parseFloat(this.removeCommas(this.max));
        this.step = parseFloat(this.removeCommas(this.step));
        this.value = parseFloat(this.removeCommas(this.value));
        this.decimals = parseFloat(this.removeCommas(this.decimals));
        this.slider = $('<div>').addClass('bubble-slider-wrap').insertAfter(this.element);
        this.minus = $('<div><span>-</span></div>').addClass('bubble-slider-minus').appendTo(this.slider);
        this.plus = $('<div><span>+</span></div>').addClass('bubble-slider-plus').appendTo(this.slider);
        this.track = $('<div>').addClass('bubble-slider-track').appendTo(this.slider);
        this.thumb = $('<div>').addClass('bubble-slider-thumb').appendTo(this.track);
        this.bubble = $('<div><span>').addClass('bubble-slider-bubble').appendTo(this.thumb);
        this.bubbleArrow = $('<div>').addClass('bubble-slider-bubble-arrow').prependTo(this.bubble);
        if (this.color) {
          this.minus.css('color', this.color);
          this.plus.css('color', this.color);
          this.thumb.css('background', this.color);
        }
        if (this.bgColor) {
          this.minus.css('border-color', this.bgColor);
          this.plus.css('border-color', this.bgColor);
          this.track.css('background', this.bgColor);
        }
        if (this.bubbleColor) {
          this.bubble.children('span').first().css('color', this.bubbleColor);
        }
        if (this.bubbleBgColor) {
          this.bubbleArrow.css('background', this.bubbleBgColor);
          this.bubble.children('span').first().css('background', this.bubbleBgColor);
        }
        this.dragging = false;
        this.limit = 1000;
        this.thumbOffset = this.thumb.outerWidth() / 2;
        this.bubbleNumber = this.bubble.find('span').first();
        this.setValue(this.value);
        this.positionThumb(this.value);
        this.thumb.css('-ms-touch-action', 'none');
        this.thumb.on('mousedown touchstart', (function(_this) {
          return function(event) {
            if (!_this.dragging) {
              event.preventDefault();
              return _this.dragging = true;
            }
          };
        })(this));
        $('html').on('mousemove touchmove', (function(_this) {
          return function(event) {
            if (_this.dragging) {
              event.preventDefault();
              if (event.type === 'touchmove') {
                return _this.dragThumb(event.originalEvent.touches[0].pageX);
              } else {
                return _this.dragThumb(event.originalEvent.pageX);
              }
            }
          };
        })(this)).on('mouseup touchend', (function(_this) {
          return function(event) {
            if (_this.dragging) {
              event.preventDefault();
              return _this.dragging = false;
            }
          };
        })(this));
        this.minus.on('click', (function(_this) {
          return function(event) {
            var newValue;
            event.preventDefault();
            newValue = _this.value - _this.step;
            newValue = Math.max(_this.min, newValue);
            _this.setValue(newValue);
            return _this.positionThumb(newValue);
          };
        })(this));
        this.plus.on('click', (function(_this) {
          return function(event) {
            var newValue;
            event.preventDefault();
            newValue = _this.value + _this.step;
            newValue = Math.min(_this.max, newValue);
            _this.setValue(newValue);
            return _this.positionThumb(newValue);
          };
        })(this));
        $(window).on('resize onorientationchange', (function(_this) {
          return function() {
            return _this.positionThumb(_this.value);
          };
        })(this));
      }

      BubbleSlider.prototype.dragThumb = function(pageX) {
        var maxPosition, minPosition, newPosition;
        minPosition = this.track.offset().left + this.thumbOffset;
        maxPosition = this.track.offset().left + this.track.outerWidth() - this.thumbOffset;
        newPosition = Math.max(minPosition, pageX);
        newPosition = Math.min(maxPosition, newPosition);
        this.setValue(this.calcValue());
        return this.thumb.offset({
          left: newPosition - this.thumbOffset
        });
      };

      BubbleSlider.prototype.calcValue = function() {
        var trackRatio;
        trackRatio = this.normalize(this.thumb.position().left, 0, this.track.outerWidth() - this.thumbOffset * 2);
        return trackRatio * (this.max - this.min) + this.min;
      };

      BubbleSlider.prototype.setValue = function(value) {
        var modValue;
        this.value = Math.round((value - this.min) / this.step) * this.step + this.min;
        this.element.val(this.value);
        modValue = this.prefix + this.addCommas(this.value.toFixed(this.decimals)) + this.postfix;
        return this.bubbleNumber.text(modValue);
      };

      BubbleSlider.prototype.positionThumb = function(value) {
        var thumbRatio;
        thumbRatio = this.normalize(value, this.min, this.max);
        return this.thumb.offset({
          left: Math.round(thumbRatio * (this.track.outerWidth() - this.thumbOffset * 2) + this.track.offset().left)
        });
      };

      BubbleSlider.prototype.normalize = function(number, min, max) {
        return (number - min) / (max - min);
      };

      BubbleSlider.prototype.addCommas = function(num) {
        return num.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
      };

      BubbleSlider.prototype.removeCommas = function(num) {
        return num.toString().replace(/,/g, '');
      };

      return BubbleSlider;

    })();
    $.fn.bubbleSlider = function(options) {
      var defaults, settings;
      defaults = {
        min: 0,
        max: 100,
        step: 1,
        value: 50,
        decimals: 0,
        prefix: '',
        postfix: '',
        color: '',
        bgColor: '',
        bubbleColor: '',
        bubbleBgColor: ''
      };
      settings = $.extend({}, defaults, $.fn.bubbleSlider.defaults, options);
      return new BubbleSlider($(this), settings);
    };
    return $(function() {
      return $('.bubble-slider').each(function() {
        return $(this).bubbleSlider();
      });
    });
  })(this.jQuery);

}).call(this);
